import { Button, CircularProgress } from "@mui/material";
import React from "react";

const SubmitButton = ({
  style,
  className,
  isLoading,
  handleClick,
  color = "secondary",
  buttonText = "Save",
  variant = "contained",
  disabled = false,
  fullWidth = false,
  hidden = false,
  ...props
}) => {
  return (
    <Button
      style={{ ...(style || {}), display: hidden ? "none" : "" }}
      color={color}
      variant={variant}
      className={className}
      onClick={handleClick}
      disabled={disabled || isLoading}
      fullWidth={fullWidth}
      {...props}
    >
      {buttonText}
      {isLoading && <CircularProgress size="14px" className="ml-2" />}
    </Button>
  );
};

export default SubmitButton;
